/**
 * localStorage-Helfer (Kopie aus lilasprojekte). Alle Schlüssel tragen das Präfix
 * `kt.` (SPEC §1.2) — dieselbe Handschrift wie `lp.` in projekte, `zp.` im
 * Zeitplaner. Das Präfix ist kein Schmuck: die Namen wandern beim Kopieren von Code
 * mit, und ohne Präfix überschriebe man der Nachbaranwendung ihr "theme".
 *
 * Alle Funktionen schlucken JEDEN Fehler und geben den Ersatzwert zurück: im privaten
 * Fenster, bei vollem Speicher und bei gesperrten Website-Daten wirft schon der bloße
 * Zugriff. Eine Oberfläche darf daran nicht sterben — sie verliert dann eben ihre
 * Merkfähigkeit, mehr nicht.
 */

export const PRAEFIX = "kt.";

export function load<T>(key: string, fallback: T): T {
  try {
    const v = localStorage.getItem(PRAEFIX + key);
    return v === null ? fallback : (JSON.parse(v) as T);
  } catch {
    return fallback;
  }
}

export function save(key: string, val: unknown): void {
  try {
    localStorage.setItem(PRAEFIX + key, JSON.stringify(val));
  } catch {
    /* Kontingent voll oder privates Fenster — ignorieren */
  }
}

export function remove(key: string): void {
  try {
    localStorage.removeItem(PRAEFIX + key);
  } catch {
    /* s. o. */
  }
}
